export const parseErrors = (logs) => {
  if (typeof logs[0] === 'string') {
    // Special case when header row is wrong. This likely means
    // they uploaded a totally wrong file.
    return [{
      row_number: 0,
      type: 'error',
      row_values: [
        'File format mismatch. Please make sure the upload file indicator in step 1 matches the input file.',
      ],
    }];
  }
  return logs.map((log) => ({ ...log, type: 'error' }));
};

export const parseValids = (logs) => logs.map((log) => ({
  ...log,
  row_values: Object.values(log.row_values),
  type: log.action,
}));
